module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#fb",
      toString: function () {
        return this.url;
      }
    }